module.exports = __webpack_public_path__ + "static/media/flags.fb51c3be.png";